<template>
    <div class="w-100" v-if="values">
        <div class="w-100 d-flex flex-column align-items-start" v-if="isEdit">
            <validation-observer
                :initialValues="{
                    quantum_login: values.gateway.quantum_login,
                    quantum_vault_key: values.gateway.quantum_vault_key,
                }"
                ref="authnet_form"
                v-slot="{ meta, setFieldError, errors }"
            >
                <validation-provider name="quantum_login" rules="required">
                    <form-input
                        label="Gateway Login:"
                        :error="errors.quantum_login"
                        v-model="values.gateway.quantum_login"
                        @input="(val) => setFieldError('quantum_login', val)"
                    />
                </validation-provider>
                <validation-provider name="quantum_vault_key" rules="required">
                    <form-input
                        label="Vault Key:"
                        type="password"
                        :error="errors.quantum_vault_key"
                        v-model="values.gateway.quantum_vault_key"
                        @input="(val) => setFieldError('quantum_vault_key', val)"
                    />
                </validation-provider>

                <p>
                    The "Vault Key" can be set within your Quantum Gateway virtual terminal by clicking on the "Secure
                    Vault" menu item and clicking on the "Edit Vault Config" link.
                </p>
                <p>
                    The Quantum Gateway is the preferred US payment gateway provider for Lodgix.com. Quantum provides
                    low rates and free access to their "secure vault".
                </p>
                <form-checkbox v-model="values.gateway.quantum_pre_auth_enabled">
                    Enable preauthorization (also called authorization hold) capability.
                </form-checkbox>
                <p>
                    To learn more and signup for a merchant account that uses the Quantum Gateway, please click
                    <a href="http://support.lodgix.com/m/5502/l/19285" target="_blank">here</a>
                </p>
                <div class="submit-buttons-wrapper">
                    <b-button :disabled="meta.valid" class="mr-2" variant="primary" @click="onSave">Save</b-button>
                    <b-button variant="default" @click="onCancel">Cancel</b-button>
                </div>
            </validation-observer>
        </div>
        <div v-else class="w-100">
            <div class="d-flex flex-column align-items-start mb-3">
                <div class="d-flex flex-column align-items-start mb-2">
                    <span>Gateway Login:</span>
                    <h3 class="text-primary cursor-pointer" @click="onEdit">{{ values.gateway.quantum_login }}</h3>
                </div>
                <div class="d-flex flex-column align-items-start mb-2">
                    <span>Vault Key:</span>
                    <h3 class="text-primary cursor-pointer" @click="onEdit">**********</h3>
                </div>
                <div class="d-flex align-items-center mb-3">
                    <h3 @click="onEdit" class="text-primary cursor-pointer mr-3">
                        {{ values.gateway.quantum_pre_auth_enabled ? 'On' : 'Off' }}
                    </h3>
                    <span>Enable preauthorization (also called authorization hold) capability.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import { paymentComponentMixin } from './mixin.js';

    export default {
        name: 'QuantumEdit',
        components: { FormInput, FormCheckbox },
        mixins: [paymentComponentMixin],
    };
</script>
